/* Single origins globe - interaction tracking for Microsoft Clarity only.
   Events: og_view, og_hover_globe, og_hover_list, og_click_globe, og_click_list, og_rotate, og_zoom, og_first_interaction
   plus per-coffee events (og_hover_<coffee>, og_click_<coffee>) and session tags (og_viewport, og_hovered, og_clicked, og_dwell).
   Add ?og_debug=1 to any URL to log every call to the browser console. */
(function () {
  'use strict';
  var DEBUG = /[?&]og_debug=1/.test(location.search);

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function slug(s) {
    return String(s || 'unknown').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 60);
  }

  ready(function () {
    var sec = document.querySelector('[data-section-type="origin-globe-master"]');
    if (!sec || sec.__ogTrack) return;
    sec.__ogTrack = true;
    var root = sec.querySelector('[data-origin-globe-master]');
    if (!root) return;

    var viewport = window.matchMedia('(max-width: 899px)').matches ? 'mobile' : 'desktop';
    var items = [].slice.call(sec.querySelectorAll('.ogm__item'));
    var meta = {};
    items.forEach(function (a, i) {
      var n = a.querySelector('.ogm__name');
      var o = a.querySelector('.ogm__origin');
      var name = n ? n.textContent.trim() : '';
      var origin = o ? o.textContent.trim() : '';
      meta[a.getAttribute('data-og-id')] = { name: (origin ? origin + ' ' : '') + name, pos: i + 1 };
    });

    var firstDone = false;
    var viewed = false;
    var interacted = false;
    var curDot = null;
    var hovered = [];
    var clicked = [];

    function cl() {
      var a = [].slice.call(arguments);
      if (DEBUG) { try { console.log('[og-track]', JSON.stringify(a)); } catch (e) {} }
      try { if (typeof window.clarity === 'function') window.clarity.apply(window, a); } catch (e) {}
    }
    function ev(name) { cl('event', name); }
    function tag(k, v) { cl('set', k, v); }
    function addTo(list, tagName, coffee) {
      if (list.indexOf(coffee) === -1) { list.push(coffee); tag(tagName, list.slice()); }
    }

    tag('og_viewport', viewport);

    function act(type, source, coffee) {
      interacted = true;
      if (!firstDone) {
        firstDone = true;
        ev('og_first_interaction');
        tag('og_first_action', type + (source ? '_' + source : ''));
      }
      if (type === 'hover' || type === 'click') {
        ev('og_' + type + '_' + source);
        if (coffee) {
          ev('og_' + type + '_' + slug(coffee));
          addTo(type === 'hover' ? hovered : clicked, type === 'hover' ? 'og_hovered' : 'og_clicked', coffee);
        }
      } else {
        ev('og_' + type);
      }
    }

    // 1. Section seen + time spent on screen
    var visibleSince = null;
    var visibleMs = 0;
    function stopClock() {
      if (visibleSince != null) { visibleMs += Date.now() - visibleSince; visibleSince = null; }
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var on = entries[0].intersectionRatio >= 0.35;
        if (on) {
          if (visibleSince == null) visibleSince = Date.now();
          if (!viewed) { viewed = true; ev('og_view'); }
        } else stopClock();
      }, { threshold: [0, 0.35, 0.6] }).observe(sec);
    }
    var dwellSent = false;
    function sendDwell() {
      if (dwellSent || !viewed) return;
      stopClock();
      var s = Math.round(visibleMs / 1000);
      if (s < 1) return;
      dwellSent = true;
      tag('og_dwell', s < 5 ? 'under_5s' : s < 15 ? '5_to_15s' : s < 30 ? '15_to_30s' : 'over_30s');
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') sendDwell();
    });
    window.addEventListener('pagehide', sendDwell);

    // 2. Hover on a dot or label on the globe (350ms dwell, same coffee once per 4s)
    var hoverTimer = null;
    var lastHover = {};
    root.addEventListener('og:hover', function (e) {
      var id = e.detail && e.detail.id;
      clearTimeout(hoverTimer);
      curDot = id != null ? String(id) : null;
      if (id == null) return;
      id = String(id);
      hoverTimer = setTimeout(function () {
        var now = Date.now();
        if (lastHover[id] && now - lastHover[id] < 4000) return;
        lastHover[id] = now;
        var m = meta[id] || {};
        act('hover', 'globe', m.name || id);
      }, 350);
    });

    // 3. Hover and click on the list (desktop)
    items.forEach(function (a) {
      var id = a.getAttribute('data-og-id');
      var m = meta[id] || {};
      var t = null;
      a.addEventListener('mouseenter', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var now = Date.now();
          var key = 'l' + id;
          if (lastHover[key] && now - lastHover[key] < 4000) return;
          lastHover[key] = now;
          act('hover', 'list', m.name);
        }, 350);
      });
      a.addEventListener('mouseleave', function () { clearTimeout(t); });
      a.addEventListener('click', function () { act('click', 'list', m.name); });
    });

    // 4. Globe: dot click, rotate by dragging, zoom
    var down = null;
    var lastRotate = 0;
    var touchTapTimer = null;
    root.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('.og-ctl')) return;
      down = { x: e.clientX, y: e.clientY, t: Date.now(), dist: 0, dot: curDot };
    });
    root.addEventListener('pointermove', function (e) {
      if (down) down.dist = Math.max(down.dist, Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y));
    });
    function up(cancelled) {
      var d = down;
      down = null;
      if (!d || cancelled) return;
      if (d.dist >= 12) {
        var now = Date.now();
        if (now - lastRotate > 5000) { lastRotate = now; act('rotate', ''); }
        return;
      }
      var id = d.dot || curDot;
      if (id) {
        var m = meta[id] || {};
        act('click', 'globe', m.name || id);
      } else if (viewport === 'mobile') {
        // Touch taps carry no hover, so a tap that leaves the page within 1s was a dot tap
        var leave = function () { act('click', 'globe', ''); };
        window.addEventListener('pagehide', leave, { once: true });
        clearTimeout(touchTapTimer);
        touchTapTimer = setTimeout(function () { window.removeEventListener('pagehide', leave); }, 1000);
      }
    }
    root.addEventListener('pointerup', function () { up(false); });
    root.addEventListener('pointercancel', function () { up(true); });

    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.og-ctl button');
      if (!b) return;
      act('zoom', '');
    });
    var lastWheel = 0;
    root.addEventListener('wheel', function (e) {
      if (!(e.ctrlKey || e.metaKey)) return;
      var now = Date.now();
      if (now - lastWheel < 3000) return;
      lastWheel = now;
      act('zoom', '');
    }, { passive: true });
  });
})();
